<div class="flex justify-center items-center text-base leading-6">
  <span
    class="text-ui-green-light font-semibold"
    [matTooltipDisabled]="!showTooltip()"
    matTooltip="Active"
  >
    {{ active() }}
  </span>
  <span class="mx-1.5">|</span>
  <span
    class="text-ui-gray-dark font-semibold"
    [matTooltipDisabled]="!showTooltip()"
    matTooltip="Paused"
  >
    {{ paused() }}
  </span>
</div>
